import { render, staticRenderFns } from "./CustomChargesSetting.vue?vue&type=template&id=7783e47e&scoped=true&"
import script from "./CustomChargesSetting.vue?vue&type=script&lang=js&"
export * from "./CustomChargesSetting.vue?vue&type=script&lang=js&"
import style0 from "./CustomChargesSetting.vue?vue&type=style&index=0&id=7783e47e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7783e47e",
  null
  
)

export default component.exports